import React, { useState } from 'react';
import Album from './Album.js';
import './Nav.css'


function Nav(props) {
  /* -------------------------------------------------------------------------- */
  /*                                   States                                   */
  /* -------------------------------------------------------------------------- */
  const [page, setPage] = useState(0)
  const [search, setSearch] = useState('')
  const [count, setCount] = useState()

  /* -------------------------------------------------------------------------- */
  /*                                   Updates                                  */
  /* -------------------------------------------------------------------------- */
  const totalCountResponse = (limit) => {
    setCount(limit)
  }

  const changePage = (num) => {
    let foo = Math.max(page + num, 0)
    if (foo*15 < count){
      setPage(foo)
    }
  }

  const searchUpdate = (srch) => {
    setPage(0)
    if (srch === '') {
      setSearch(srch)
    } else {
      setSearch('nameStartsWith=' + srch)
    }
  }

  const pageUpdate = () => {
    return (<Album limitCharge={(foo)=>totalCountResponse(foo)} url={'https://gateway.marvel.com/v1/public/characters?' + search + '&limit=15&offset=' + Math.min(page * 15, count) + '&ts=1&apikey=75b1c8b881373da5882ace7f18273c48&hash=2d38fb5f4a6aef1f712440662c9454f0'}/>)
  }

  /* -------------------------------------------------------------------------- */
  /*                                     JSX                                    */
  /* -------------------------------------------------------------------------- */
  return (
    <nav>
      <form>
        <input type='text' onChange={(e) => searchUpdate(e.target.value)} placeholder='Buscar Personaje'></input>
      </form>
      <div className='paginator'>
      <button onClick={() => changePage(-1)}>
        <img className='button-arrow' src='./left.svg'/>
      </button>
      Pagina {page + 1}
      <button onClick={() => changePage(1)}>
        <img className='button-arrow' src='./right.svg'/>
      </button>
      </div>

      <h6>Resultados totales: {count}</h6>
      {pageUpdate()}
    </nav>
  )
}

export default Nav;
